import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

import { paths } from '../routing-paths';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.authenticationService.currentFirebaseAuthUser.then(user => {
            if (user) {
                return true;
            }

            const currentAuth = this.authenticationService.currentDisplayAuthValue;
            if (currentAuth) {
                // logged in so return true
                return true;
            }

            // not logged in so redirect to login page with the return url
            this.router.navigate([paths.LOGIN], { queryParams: { returnUrl: state.url } });
            return false;
        });
    }
}
